//
// Copyright (c) 2011-2017 by Curalate, Inc.
//


// This directive attaches a thumbnail popover to the desired image
// Note: the directive should be attached to a parent of the desired image element
(function() {
  angular.module('curalate').directive('thumbnailPopover', () => ({
    restrict: 'AC',
    scope: {
      meta: '=',
    },
    transclude: false,
    link(scope, element) {
                // TODO: when popover is restyled, adjust and angularize directive
      const $img = element.find('img');
      CURALATE.tables.attachThumbnailPopover(element, scope.meta, $img);
    },
  }));
})();
